import React from 'react';
import PropTypes from 'prop-types';
import { generate } from 'shortid';
import style from './CircularProgressbar.css';

class CircularProgressbar extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      percentage: props.initialAnimation ? 0 : props.percentage,
    };

    this.id = generate();
  }

  componentDidMount() {
    if (this.props.initialAnimation) {
      this.initialTimeout = setTimeout(() => {
        this.requestAnimationFrame = window.requestAnimationFrame(() => {
          this.setState({
            percentage: this.props.percentage,
          });
        });
      }, 0);
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      lastPercent: this.state.percentage,
      percentage: nextProps.percentage,
    });
  }

  componentWillUnmount() {
    clearTimeout(this.initialTimeout);
    window.cancelAnimationFrame(this.requestAnimationFrame);
  }

  render() {
    const borderRadius = 50;
    const radius = (borderRadius - this.props.strokeWidth / 2);
    const pathDescription = `
      M ${borderRadius},${borderRadius} m 0,-${radius}
      a ${radius},${radius} 0 1 1 0,${2 * radius}
      a ${radius},${radius} 0 1 1 0,-${2 * radius}
    `;

    const diameter = Math.PI * 2 * radius;
    const progressStyle = {
      strokeDasharray: `${diameter}px ${diameter}px`,
      strokeDashoffset: `${((100 - this.state.percentage) / 100 * diameter)}px`,
    };
    const { caption, text, strokeWidth, classForPercentage = '' } = this.props;

    return (
      <div className={`${style.CircularProgressbar} ${classForPercentage}`}>
        <svg viewBox="0 0 100 100">
          <linearGradient id={this.id}>
            <stop offset="0%" stopColor="#f8e090" stopOpacity="1" />
            <stop offset="50%" stopColor="#f8e090" stopOpacity="1" />
            <stop offset="100%" stopColor="#f8e090" stopOpacity="1" />
          </linearGradient>

          <path
            className={style.CircularProgressbarTrail}
            d={pathDescription}
            strokeWidth={1}
            fillOpacity={0}
          />

          <path
            className={ `${style.CircularProgressbarPath} ${this.state.lastPercent === 0 ? style.lastPercent : ''}` }
            d={ pathDescription }
            strokeWidth={strokeWidth}
            fillOpacity={0}
            style={progressStyle}
            stroke={`url(#${this.id})`}
          />
        </svg>
        <div className={style.CircularProgressbarNumber}>{text}</div>
        <div className={style.CircularProgressbarCaption}>{ caption }</div>
      </div>
    );
  }
}

CircularProgressbar.propTypes = {
  percentage: PropTypes.number.isRequired,
  strokeWidth: PropTypes.number,
  initialAnimation: PropTypes.bool,
  classForPercentage: PropTypes.string,
  textForPercentage: PropTypes.func,
};

CircularProgressbar.defaultProps = {
  percentage: 0,
  text: 0,
  strokeWidth: 3,
  caption: '秒',
  initialAnimation: false,
};

export default CircularProgressbar;



// WEBPACK FOOTER //
// ./src/components/CircularProgressbar/index.js